import * as React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import TopAppBar from 'components/AppBar/AppBar';
import MyVehiclesList from './vehicles/list/MyVehiclesList';

const Dashboard = () => {
  const { pathname } = useLocation();

  return (
    <div
      style={{
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        overflow: 'hidden',
      }}
    >
      <TopAppBar />
      <div
        id="dashboardContentContainer"
        style={{
          position: 'relative',
          flexGrow: 1,
          flexDirection: 'column',
          width: '100%',
          height: 'calc(100% - 64px)',
          padding: '20px',
          overflow: 'auto',
        }}
      >
        <Outlet></Outlet>
        {pathname === '/home' ? <MyVehiclesList /> : null}
      </div>
    </div>
  );
};

export default Dashboard;
